import { render, staticRenderFns } from "./ChangeLanguageButton.vue?vue&type=template&id=675ce918&"
import script from "./ChangeLanguageButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChangeLanguageButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ChangeLanguageButton.vue?vue&type=style&index=0&id=675ce918&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675ce918')) {
      api.createRecord('675ce918', component.options)
    } else {
      api.reload('675ce918', component.options)
    }
    module.hot.accept("./ChangeLanguageButton.vue?vue&type=template&id=675ce918&", function () {
      api.rerender('675ce918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ChangeLanguage/ChangeLanguageButton.vue"
export default component.exports